
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.isReady().then(() => {
        // Resolve the current path against the new routes to get updated meta
        const newRoute = router.resolve(router.currentRoute.value.fullPath)
        // Clear old meta values and assign new ones
        for (const key of Object.keys(router.currentRoute.value.meta)) {
          delete router.currentRoute.value.meta[key]
        }
        Object.assign(router.currentRoute.value.meta, newRoute.meta)
      })
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as indexECb_KsqEZyqAfa90yogtmx_0eO1spQH7IchEa5lKYDcMeta } from "/app/packages/website-builder/app/pages/index.vue?macro=true";
import { default as _91_46_46_46slug_93CTPK4txsjMuwnRRv0KND_VgOgCtFkT0O8WumVBLqAXIMeta } from "/app/packages/website-builder/app/pages/[...slug].vue?macro=true";
import { default as sec_45filingsRRpmehMl0BAWQR_CA77iB_YDbmbk2DTMMGKH0_bB0zMMeta } from "/app/packages/website-builder/app/pages/sec-filings.vue?macro=true";
import { default as ir_45emails_45alertsooUyQ9gRYGGUCRz80fXs_CoqoglVw0TgOjCCOGA4fjgMeta } from "/app/packages/website-builder/app/pages/ir-emails-alerts.vue?macro=true";
import { default as ir_45emails_45unsubscribeoU1IMzai8FMrVVBhGbXdECvpyn5vJn587l1dm6a4Pm4Meta } from "/app/packages/website-builder/app/pages/ir-emails-unsubscribe.vue?macro=true";
import { default as _91id_93_45_91slug_93OqtcCL_avMmxpL1BRG2wzvDnb_72ISb76Chl_TkS_p8Meta } from "/app/packages/website-builder/app/pages/press-releases/[id]-[slug].vue?macro=true";
import { default as _91slug_93qMaRW_0mN231Cb28kDDkc38GVgbtuIsH5jhgoc25PosMeta } from "/app/packages/website-builder/app/pages/news/[year]/[month]/[day]/[slug].vue?macro=true";
export default [
  {
    name: "index",
    path: "/",
    component: () => import("/app/packages/website-builder/app/pages/index.vue")
  },
  {
    name: "slug",
    path: "/:slug(.*)*",
    meta: _91_46_46_46slug_93CTPK4txsjMuwnRRv0KND_VgOgCtFkT0O8WumVBLqAXIMeta || {},
    component: () => import("/app/packages/website-builder/app/pages/[...slug].vue")
  },
  {
    name: "sec-filings",
    path: "/sec-filings",
    component: () => import("/app/packages/website-builder/app/pages/sec-filings.vue")
  },
  {
    name: "ir-emails-alerts",
    path: "/ir-emails-alerts",
    component: () => import("/app/packages/website-builder/app/pages/ir-emails-alerts.vue")
  },
  {
    name: "ir-emails-unsubscribe",
    path: "/ir-emails-unsubscribe",
    component: () => import("/app/packages/website-builder/app/pages/ir-emails-unsubscribe.vue")
  },
  {
    name: "press-releases-id-slug",
    path: "/press-releases/:id()-:slug()",
    meta: _91id_93_45_91slug_93OqtcCL_avMmxpL1BRG2wzvDnb_72ISb76Chl_TkS_p8Meta || {},
    component: () => import("/app/packages/website-builder/app/pages/press-releases/[id]-[slug].vue")
  },
  {
    name: "news-year-month-day-slug",
    path: "/news/:year()/:month()/:day()/:slug()",
    meta: _91slug_93qMaRW_0mN231Cb28kDDkc38GVgbtuIsH5jhgoc25PosMeta || {},
    component: () => import("/app/packages/website-builder/app/pages/news/[year]/[month]/[day]/[slug].vue")
  }
]